import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"position":"fixed","left":"-200%"} }

import { onMounted, onBeforeUnmount } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const handleElementAClick = (e: Event) => {
    const target = (e.target as HTMLElement).closest('a');
    if (target) {
      e.preventDefault();
    }
  };
  onMounted(() => {
    document.addEventListener('click', handleElementAClick);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleElementAClick);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})